<div class="row no-gutters" *ngIf="patientDetails">
  <dt class="col-sm-12  mt-2 mb-2 text-default text-center">
    <span>Address Details</span>
    <i class="fa fa-edit text-info ml-2 cursor" matTooltip="Edit Patient Address" matTooltipPosition="right"
      *ngIf="!editPatientsAddress && patientDetails.IsArchived===0" (click)="editPatientAddress()"></i>
  </dt>
  <div *ngIf="!editPatientsAddress">
    <div *ngIf="!patientDetails.AddressLine1 && !patientDetails.City && !patientDetails.Postcode">
      No Address found
    </div>
    <div class="row w-100 pl-0 pr-0 ml-0 mr-0"
      *ngIf="patientDetails.AddressLine1 || patientDetails.City || patientDetails.Postcode">
      <dt class="col-sm-5" *ngIf="patientDetails.AddressLine1">Address Line 1</dt>
      <dd class="col-sm-7" *ngIf="patientDetails.AddressLine1">{{patientDetails.AddressLine1}}
      </dd>
      <dt class="col-sm-5" *ngIf="patientDetails.AddressLine2">Address Line 2</dt>
      <dd class="col-sm-7" *ngIf="patientDetails.AddressLine2">{{patientDetails.AddressLine2}}
      </dd>
      <dt class="col-sm-5" *ngIf="patientDetails.AddressLine3">Address Line 3</dt>
      <dd class="col-sm-7" *ngIf="patientDetails.AddressLine3">{{patientDetails.AddressLine3}}
      </dd>
      <dt class="col-sm-5" *ngIf="patientDetails.City">City</dt>
      <dd class="col-sm-7" *ngIf="patientDetails.City">{{patientDetails.City}}</dd>
      <dt class="col-sm-5" *ngIf="patientDetails.County">County</dt>
      <dd class="col-sm-7" *ngIf="patientDetails.County">{{patientDetails.County}}</dd>
      <dt class="col-sm-5" *ngIf="patientDetails.PostCode">Postcode</dt>
      <dd class="col-sm-7" *ngIf="patientDetails.PostCode">{{patientDetails.PostCode}}</dd>
    </div>
  </div>
  <div *ngIf="editPatientsAddress" class="w-100">
    <form [formGroup]="addressForm">
      <div class="row no-gutters pl-0 pr-0 ml-0 mr-0">
        <div class="form-group w-60">
          <input type="text" class="form-control form-control-sm" placeholder="Postal Code *" formControlName="PostCode"
            required maxlength="8" minlength="6"
            [ngClass]="{'red-border-class': addressFormSubmitted && addressForm.controls['PostCode'].errors}">
        </div>
        <div class="form-group w-40">
          <input type="submit" (click)="FindEditAddress()" value="Find Address"
            class="btn btn-primary btn-find-address btn-sm">
        </div>
      </div>
      <div class="form-group" *ngIf="AllEditAddress">
        <select formControlName="Addresses" class="form-control form-control-sm" (change)="getEditAddress($event)">
          <option *ngFor="let address of AllEditAddress">{{address}}
          </option>
        </select>
      </div>
      <div *ngIf="AllEditAddress">
        <div class="form-group">
          <input type="text" class="form-control form-control-sm" placeholder="AddressLine 1 *"
            formControlName="AddressLine1" required id="AddressLine1"
            [ngClass]="{'red-border-class': addressFormSubmitted && addressForm.controls['AddressLine1'].errors}">
        </div>
        <div class="form-group">
          <input type="text" class="form-control form-control-sm" placeholder="AddressLine 2"
            formControlName="AddressLine2" id="AddressLine2">
        </div>
        <div class="form-group">
          <input type="text" class="form-control form-control-sm" placeholder="AddressLine 3"
            formControlName="AddressLine3" id="AddressLine3">
        </div>
        <div class="form-group">
          <input type="text" class="form-control form-control-sm" placeholder="City *" formControlName="City" required
            id="city" [ngClass]="{'red-border-class': addressFormSubmitted && addressForm.controls['City'].errors}">
        </div>
        <div class="form-group">
          <input type="text" class="form-control form-control-sm" placeholder="County" formControlName="County"
            id="County">
        </div>
      </div>

      <div class="row no-gutters">
        <button type="button" class="btn btn-success mr-2" (click)="savePatientAddress()">Save</button>
        <button type="button" class="btn btn-danger" (click)="cancelPatientAddress()"
          data-dismiss="modal">Cancel</button>
      </div>
    </form>
  </div>
</div>
<app-toast-message></app-toast-message>